import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SpraAmcvParams, SpraApprovalParams, SpraCsaRate,SpraAmcvTotalValue, AMCVProfitablity } from 'src/app/Models/ops';
import { GetSpraPriceParam, OpsProduct } from 'src/app/Models/product';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import {Mutex, MutexInterface, Semaphore, SemaphoreInterface, withTimeout} from 'async-mutex';


@Component({
  selector: 'app-spra-amcv',
  templateUrl: './spra-amcv.component.html',
  styleUrls: ['./spra-amcv.component.css']
})
export class SpraAmcvComponent implements OnInit {
  @Output("GetAMCVTotalValues") GetAMCVTotalValues: EventEmitter<any> = new EventEmitter(); 
  @Output("BindCsaUnitPrice") BindCsaUnitPrice: EventEmitter<any> = new EventEmitter(); 
  MachineLife?: number;
  SpraAmcvParams: Array<SpraAmcvParams>;
  SpraApprovalParams: SpraApprovalParams;
  spraAmcvTotalValue:SpraAmcvTotalValue; 
  SaleType: string;
  spraCSARate: Array<SpraCsaRate>;
  ProfitTag: boolean;
  AMCVProfitablity:AMCVProfitablity;
  // TotalSale: number;
  // TotalPriceList: number;
  // GPSale: string;
  // GPPriceList: number;
  // GrandTotSale: number;
  // GrandTotPriceList: number;
  // TotalWSNSP: number;
  // TotalLandedCost: number;
  // TotalBookLC: number;
  // GPriceList: string;
  // GPWSNSP: string;
  // GPLandedCost: string;
  // GPBookLC: string;
  ProductCodes: any[] = [];
  DistanceID: Array<number>;
  AmcvFGProductParams: Array<OpsProduct>;
  PriceListApiCount:number = 0;
  TC:number = 0;
  CaltotValTag:string;
  private utility: Utility;
  constructor(private _MasterService: MasterService,
    private cookieService: CookieService,
    private _NotificationService: NotificationService
  ) {
    this.SpraAmcvParams = new Array<SpraAmcvParams>();
    this.SpraApprovalParams = new SpraApprovalParams();
    this.spraCSARate = new Array<SpraCsaRate>();
    this.spraAmcvTotalValue =new SpraAmcvTotalValue();
    this.AmcvFGProductParams= new Array<OpsProduct>();
    this.SaleType = "";
    this.utility = new Utility(this.cookieService);
    this.ProfitTag = false;
    this.AMCVProfitablity = new AMCVProfitablity();
    // this.TotalSale = 0;
    // this.TotalPriceList = 0;
    // this.GPPriceList = 0;
    // this.GPSale = "0";
    // this.GrandTotSale = 0;
    // this.GrandTotPriceList = 0;
    // this.TotalWSNSP = 0;
    // this.TotalLandedCost = 0;
    // this.TotalBookLC = 0;
    // this.GPriceList = "0";
    // this.GPWSNSP = "0";
    // this.GPLandedCost = "0";
    // this.GPBookLC = "0";
    this.DistanceID=[];
    this.CaltotValTag="N";
  }


  ngOnInit(): void {
  }




  onProductCodeKeypress(event: any, spraAmcvParams: SpraAmcvParams) {
    if (event.key != "ArrowDown" && event.key != "ArrowUp") {
      if (event.target.value.length > 2) {
        this.ProductCodes=[];
        spraAmcvParams.ProductCode=event.target.value;
        this.BindProduct(spraAmcvParams);
      } else {
        this.ProductCodes = [];
      }
    }
  }

  BindProduct(spraAmcvParams: SpraAmcvParams) {
    this._MasterService.GetAllProductByTechnicalId(spraAmcvParams.TechnicalId, spraAmcvParams.ProductId, spraAmcvParams.ProductCode).subscribe((d) => {
      if(d && d!=""){ 
      let _ProductCodes:any[]=[];
      _ProductCodes  = _ProductCodes.concat(JSON.parse(d.toString()));
      // this.ProductCodes = this.ProductCodes.concat(JSON.parse(d.toString()));
      this.ProductCodes = this.ProductCodes.concat(_ProductCodes);
      
      if (this.ProductCodes.length == 1) {
        spraAmcvParams.ProductId = this.ProductCodes[0].productid;
      }
    }
    });
  }



  ChangeProduct(_spraAmcvParams: SpraAmcvParams) {
    this.SpraAmcvParams.forEach((item,index)=>{
      if (
          (item.TechnicalId != undefined && item.TechnicalId == _spraAmcvParams.TechnicalId && item.CounterDesc.split(" ")[0] == _spraAmcvParams.CounterDesc.split(" ")[0]  )
          ||
          (item.TechnicalId == undefined && item.CounterDesc.split(" ")[0] == _spraAmcvParams.CounterDesc.split(" ")[0] )
        ){
          if(_spraAmcvParams.ProductId != undefined){
            item.ProductId = _spraAmcvParams.ProductId;
          }
        this.BindConsumableYieldAndPrice(item,index);
      }
    })

    
 //end of addition by swati
  }


BindConsumableYieldAndPrice(spraAmcvParams: SpraAmcvParams,index:number){
  let _GetSpraPriceParam: GetSpraPriceParam = new GetSpraPriceParam();
    _GetSpraPriceParam.PriceType = "SALE";
    if(this.SaleType == "DD" || this.SaleType == "DL"){
      _GetSpraPriceParam.PriceListTypeCode = "PLDD";
    }else if(this.SaleType == "LL"){
      _GetSpraPriceParam.PriceListTypeCode = "PLLL";
    }

    if (spraAmcvParams.ProductId != undefined) {
      _GetSpraPriceParam.ProductId = spraAmcvParams.ProductId
    }

    this._MasterService.GetSpraPrice(_GetSpraPriceParam).subscribe((d) => {
      if (d) {
        let productprice: any = JSON.parse(d.toString());
        spraAmcvParams.Price = productprice.PriceValue;

        // added by swati on 19/04/2021
        if((spraAmcvParams.Price !=undefined) && (spraAmcvParams.Price>0))
        {
          spraAmcvParams.IsPriceExists=true;
        }
        else
        {
          spraAmcvParams.IsPriceExists=false;
        }
       // end of addition by swati on 19/04/2021

      }
    });


    this._MasterService.GetProductYield(_GetSpraPriceParam.ProductId).subscribe((d) => {
      if (d && d != "null") {
        let ProductYield: any = JSON.parse(d.toString());
        spraAmcvParams.yeild = ProductYield.yield;
        this.calculateYiead(spraAmcvParams);
      } else {
        spraAmcvParams.yeild = 0;
        this.calculateYiead(spraAmcvParams);
      }
    });

 //added by swati on 07/04/2021 
  //  this.GetSPRAPriceListData(spraAmcvParams,spraAmcvParams.CounterId,this.SaleType,this.DistanceID,0,0,0,0);
   setTimeout(() => {
    if(this.ProfitTag==true)
    {
      if(index == this.SpraAmcvParams.length-1){
        this.CalculateTotalSaleValue();
      }      
    }
   },1500);
  
}



  ChangeProductPrice(spraAmcvParams: SpraAmcvParams) {
    
  if((spraAmcvParams.TotalQtyConsumption!=undefined )&& (spraAmcvParams.Price!=undefined))
  {
      spraAmcvParams.TotSaleVal = spraAmcvParams.TotalQtyConsumption* spraAmcvParams.Price;
  }
  setTimeout(() => {
    if(this.ProfitTag==true)
    {
      this.CaltotValTag='N';        
      this.CalculateTotalSaleValue();
    }      
  }, 1000);
  }

  calculateYiead(spraAmcvParams: SpraAmcvParams) {
    if (spraAmcvParams.TotalCopy != undefined && spraAmcvParams.yeild != undefined && spraAmcvParams.yeild !=0) {
      spraAmcvParams.TotalQtyConsumption = Math.ceil((spraAmcvParams.TotalCopy / spraAmcvParams.yeild));
      spraAmcvParams.IsTotQtyConsExists =true;

    } 
    // commented by rajan singh on 17/06/2021 -- as for the product that doest not have yield    -- TotalQtyConsumption updating zero
    //else {
      // spraAmcvParams.TotalQtyConsumption = 0;
      // spraAmcvParams.IsTotQtyConsExists =false;
    //}
  }

  EmclChange(_spraAmcvParams: SpraAmcvParams) {
    this.SpraAmcvParams.forEach((item)=>{
      if (item.CounterId == _spraAmcvParams.CounterId){
        if (_spraAmcvParams.EMCL != undefined){
          item.EMCL = _spraAmcvParams.EMCL;
        }
        
        this.AutoBindColorCounterEmcl(item);
        // alert(item.EMCL);
      //   item.EMCL = spraAmcvParams.EMCL;
      //   if(item.EMCL != undefined && this.MachineLife != undefined){
      //     item.TotalCopy = (item.EMCL * 12 * this.MachineLife)
      //   }        
      // if (item.CounterVal != undefined && item.TotalCopy != undefined) {
      //   item.TotalCounterValue = (item.TotalCopy * item.CounterVal)
      // }

      }
    })


   
    
  }

  AutoBindColorCounterEmcl(spraAmcvParams: SpraAmcvParams){
    if (spraAmcvParams.EMCL != undefined && this.MachineLife != undefined) {
      spraAmcvParams.TotalCopy = (spraAmcvParams.EMCL*spraAmcvParams.Qty*12 * this.MachineLife)
      if (spraAmcvParams.CounterVal != undefined) {
        spraAmcvParams.TotalCounterValue = (spraAmcvParams.TotalCopy * spraAmcvParams.CounterVal)
      }
      if (this.SpraApprovalParams.DayOneCSA)
      {
        setTimeout(() => {
          if(this.ProfitTag==true)
          {              
            this.CalculateTotalSaleValue();
          }
          }, 1000);
      }

    
      this.CalculateA3CopyLoad();
      this.calculateYiead(spraAmcvParams);
    } else {
      // spraAmcvParams.EMCL = 0;
      spraAmcvParams.TotalCopy = 0;
      this.calculateYiead(spraAmcvParams);
    }
  }



  CalculateA3CopyLoad(CounterId: number = 0) {
    // this.SpraAmcvParams.filter(function (item: SpraAmcvParams) {
    //   return ([1, 2, 5].indexOf(item.CounterId) >= 0 && CounterId == 0) || (item.CounterId == CounterId)
    // }).forEach((element: SpraAmcvParams) => {

    this.SpraAmcvParams.filter(function (item: SpraAmcvParams) {
      return ([3, 4].indexOf(item.CounterId) >= 0 && CounterId == 0) || (item.CounterId == CounterId)
    }).forEach((element: SpraAmcvParams) => {

      element.IsA3RatioEntered = false;
      let A4Counter:number = 0;
      let A3CopyRatio:number = 0;
      let TechnicalId:number = (element.TechnicalId!=undefined?element.TechnicalId:0)
      if (element.CounterId==3 && this.SpraApprovalParams.BlackA3CopyRatio != undefined){
          A4Counter = 1;
          A3CopyRatio = this.SpraApprovalParams.BlackA3CopyRatio;
      }
      else if (element.CounterId==4 && this.SpraApprovalParams.ColorA3CopyRatio != undefined)
     {
          A4Counter = 2;
          A3CopyRatio = this.SpraApprovalParams.ColorA3CopyRatio;
     }
     
     if(A4Counter >0 && A3CopyRatio>0){
      this.BindA3CopyLoad(element,element.CounterId,A4Counter,A3CopyRatio,TechnicalId);
      }

    });



    // });
  }



BindA3CopyLoad(element:SpraAmcvParams,A3Counter:number,A4Counter:number,BlackA3CopyRatio:number,TechnicalId:number){
  let A4SpraAmcvParams: SpraAmcvParams = new SpraAmcvParams();
  if (element.CounterId == A3Counter) {
    A4SpraAmcvParams = this.SpraAmcvParams.filter(function (item: SpraAmcvParams) {
      return item.CounterId == A4Counter && item.TechnicalId == TechnicalId
    })[0];
    if (A4SpraAmcvParams != undefined && this.MachineLife != undefined 
        && A4SpraAmcvParams.EMCL != undefined && BlackA3CopyRatio != undefined           
      ) {
      element.EMCL = Math.ceil(A4SpraAmcvParams.EMCL*BlackA3CopyRatio/100);      
      element.TotalCopy = Math.ceil(element.EMCL*element.Qty*12*this.MachineLife);
      element.IsA3RatioEntered = true;
      this.calculateYiead(element);

    }

  }
}


  MachineLifeChange(){    
    this.SpraAmcvParams.forEach((element:SpraAmcvParams) => {
      this.EmclChange(element);
    })
  }

 
  Validation(): boolean {
    if (this.SpraAmcvParams.length > 0 && !this.utility.CheckNumberRequired(this.MachineLife)) {
      this._NotificationService.showError("Please enter Machine Life.", "AMCV");
      return false
    }

    let i: number = 0
    for (i; i < this.SpraAmcvParams.length; i++) {
      if (!this.utility.CheckNumberRequired(this.SpraAmcvParams[i].EMCL)) {
        this._NotificationService.showError("Please enter Estimated Monthly Copy Load of " + this.SpraAmcvParams[i].CounterDesc + " .", "AMCV");
        return false;
      }
      else if (!this.SpraApprovalParams.DayOneCSA && !this.utility.CheckNumberRequired(this.SpraAmcvParams[i].ProductId)) {
        this._NotificationService.showError("Please select cons. part code for " + this.SpraAmcvParams[i].CounterDesc + " .", "AMCV");
        return false;
      }
      
      else if (!this.SpraApprovalParams.DayOneCSA && !this.utility.CheckNumberRequired(this.SpraAmcvParams[i].TotalQtyConsumption)) {
        this._NotificationService.showError("Please enter Cons. Total Qty Consumtion for " + this.SpraAmcvParams[i].CounterDesc + " .", "AMCV");
        return false;
      }
      else if (!this.SpraApprovalParams.DayOneCSA && !this.utility.CheckNumberRequired(this.SpraAmcvParams[i].Price)) {
        this._NotificationService.showError("Please enter Cons. Unit Price for " + this.SpraAmcvParams[i].CounterDesc + " .", "AMCV");
        return false;
      }

    }
    return true;

  }

  CalculateTotalSaleValue() {
    // alert("CalculateTotalSaleValue");
    let OrderRate: number = 0;
    let CSARate: SpraCsaRate;
    this.AMCVProfitablity = new AMCVProfitablity();
    // this.TotalSale = 0;
    // this.TotalPriceList = 0;
    // this.GPPriceList = 0;
    // this.GPSale = "0";
    // this.GrandTotSale = 0;
    // this.GrandTotPriceList = 0;
    // this.TotalWSNSP = 0;
    // this.TotalLandedCost = 0;
    // this.TotalBookLC = 0;
    // this.GPriceList = "0";
    // this.GPWSNSP = "0";
    // this.GPLandedCost = "0";
    // this.GPBookLC = "0"; 
    let index:number =0 ;
    this.PriceListApiCount = 0;
    // let Amcvindex:number =0 ;
    let TotProdQty:number =0; 
    let TotNumOFProd:number=0;
    this.AmcvFGProductParams.forEach((item: OpsProduct)=>{
      TotProdQty=TotProdQty + item.pQty;
    });
    this.TC = 0;
    this.SpraAmcvParams.forEach(async (element: SpraAmcvParams,Amcvindex:number) => {     
      // setTimeout(() => {
      if (this.SpraApprovalParams.DayOneCSA){
        TotNumOFProd=this.AmcvFGProductParams.length;       
        this.TC =  (this.AmcvFGProductParams.length*this.SpraAmcvParams.length*this.DistanceID.length);
        index=0;
        

        //Quantity Taken to compute the CSA price based on the distance and quantity.
        let FGQty: Array<number>;
        FGQty = new Array<number>();
        Promise.all(this.AmcvFGProductParams.map(async (item: OpsProduct)=>{                    
          if(element.ProductList.find(p => p == item.PId)){
            FGQty.push(item.Quantity);
          }
          element.ProductId=item.PId;     
           index = index+1;
        }));
        await this.GetSPRAPriceListData(element,element.CounterId,"CSA",this.DistanceID,index,0,TotNumOFProd,TotProdQty, 0, FGQty);
        
        
      }else{
        // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
        // console.log(Amcvindex)
        // console.log(this.SpraAmcvParams.length)
        // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
        let GetSPRAPriceListData =  this.GetSPRAPriceListData(element,element.CounterId,this.SaleType,this.DistanceID,Amcvindex,0,this.SpraAmcvParams.length,0);
      }

    //   if(Amcvindex == this.SpraAmcvParams.length-1)
    //   {
    //     setTimeout(() => {

    //       // commented by rajan singh on 14 july as - its calculating the sale value ony one time -->> if user changes the FG Quantity - was not recalculating total sale value
    //       // if(this.CaltotValTag == "N")
    //       //  {
    //         // console.log(1);
    //         this.CalculateGrandTotal();
    //         //this.CaltotValTag="Y";
    //     //  }
        
    //     },1000);
    //     // alert("Total");
    //   }
    // // });
            
    });
  }

  CalculateGrandTotal()
  {
    // alert("CalculateGrandTotal");
    let OrderRate: number = 0;
    let CSARate: SpraCsaRate;
    // this.AMCVProfitablity = new AMCVProfitablity();
    let _AMCVProfitablity:AMCVProfitablity = new AMCVProfitablity();
    // this.TotalSale = 0;
    // this.TotalPriceList = 0;
    // this.GPPriceList = 0;
    // this.GPSale = "0";
    // this.GrandTotSale = 0;
    // this.GrandTotPriceList = 0;
    // this.TotalWSNSP = 0;
    // this.TotalLandedCost = 0;
    // this.TotalBookLC = 0;
    // this.GPriceList = "0";
    // this.GPWSNSP = "0";
    // this.GPLandedCost = "0";
    // this.GPBookLC = "0"; 
    if(this.SpraAmcvParams != undefined && this.SpraAmcvParams.length<=0){
      this.EmiAMCVTotalValues(_AMCVProfitablity);
    }else{

      this.SpraAmcvParams.forEach((element: SpraAmcvParams,index:number) => {

        if (this.SpraApprovalParams.DayOneCSA) {
          CSARate = this.spraCSARate.filter((item) => { return item.CounterId == element.CounterId })[0];
          if ((element.TotalCopy != undefined) && (CSARate!= undefined && CSARate.OrderRate != undefined)) {
            element.TotalSaleValue = this.utility.RoundOff(element.TotalCopy * CSARate.OrderRate);
          }
          _AMCVProfitablity.TotalSale = _AMCVProfitablity.TotalSale + element.TotalSaleValue;
  
          // if (element.TotalCounterValue != undefined) {
          //   this.TotalPriceList = this.TotalPriceList + element.TotalCounterValue;
          // }
          // this.GPSale = (((this.TotalSale - this.TotalPriceList) / (this.TotalSale)) * 100).toFixed(2);
          if ((element.PriceList != undefined) && (element.TotalCopy != undefined)) {
            _AMCVProfitablity.GrandTotPriceList = _AMCVProfitablity.GrandTotPriceList + element.PriceList;
          
          }
          if ((element.WorkSheetNSP != undefined) && (element.TotalCopy != undefined)) {
            _AMCVProfitablity.TotalWSNSP = _AMCVProfitablity.TotalWSNSP + element.WorkSheetNSP;
          
          }
          if ((element.WorkSheetLanded != undefined) && (element.TotalCopy != undefined)){
            _AMCVProfitablity.TotalLandedCost = _AMCVProfitablity.TotalLandedCost + element.WorkSheetLanded;
           
          }
          if ((element.BookingLanded != undefined) && (element.TotalCopy != undefined)){
            
            _AMCVProfitablity.TotalBookLC = _AMCVProfitablity.TotalBookLC + element.BookingLanded;
            
          }
          this.spraAmcvTotalValue.TotBookingLanded= _AMCVProfitablity.TotalBookLC;
          this.spraAmcvTotalValue.TotSaleValue= _AMCVProfitablity.TotalSale;
          this.spraAmcvTotalValue.TotPriceList= _AMCVProfitablity.GrandTotPriceList;
          this.spraAmcvTotalValue.TotWorkSheetLanded= _AMCVProfitablity.TotalLandedCost;
          this.spraAmcvTotalValue.TotWorkSheetNSP= _AMCVProfitablity.TotalWSNSP;
  
          if(_AMCVProfitablity.TotalSale!=0)
          {
            _AMCVProfitablity.GPriceList = (((_AMCVProfitablity.TotalSale - _AMCVProfitablity.GrandTotPriceList) / (_AMCVProfitablity.TotalSale)) * 100).toFixed(2);
            _AMCVProfitablity.GPWSNSP = (((_AMCVProfitablity.TotalSale - _AMCVProfitablity.TotalWSNSP) / (_AMCVProfitablity.TotalSale)) * 100).toFixed(2);
            _AMCVProfitablity.GPLandedCost = (((_AMCVProfitablity.TotalSale - _AMCVProfitablity.TotalLandedCost) / (_AMCVProfitablity.TotalSale)) * 100).toFixed(2);
            _AMCVProfitablity.GPBookLC = (((_AMCVProfitablity.TotalSale - _AMCVProfitablity.TotalBookLC) / (_AMCVProfitablity.TotalSale)) * 100).toFixed(2);
            _AMCVProfitablity.GPriceList =   _AMCVProfitablity.GPriceList +"%";
            _AMCVProfitablity.GPWSNSP =   _AMCVProfitablity.GPWSNSP +"%";
            _AMCVProfitablity.GPLandedCost =   _AMCVProfitablity.GPLandedCost +"%";
            _AMCVProfitablity.GPBookLC =   _AMCVProfitablity.GPBookLC +"%";
            
          }
  
        }
        else {
          if (element.TotalQtyConsumption != undefined && element.Price != undefined) {
            element.TotSaleVal = element.TotalQtyConsumption * element.Price;
            _AMCVProfitablity.GrandTotSale = _AMCVProfitablity.GrandTotSale + element.TotSaleVal;
          }
          if ((element.PriceList != undefined) && (element.TotalQtyConsumption != undefined)) {
            _AMCVProfitablity.GrandTotPriceList = _AMCVProfitablity.GrandTotPriceList + element.TotalQtyConsumption *element.PriceList;
            element.PriceList= element.TotalQtyConsumption * element.PriceList;
          }
          if ((element.WorkSheetNSP != undefined) && (element.TotalQtyConsumption != undefined)) {
            _AMCVProfitablity.TotalWSNSP = _AMCVProfitablity.TotalWSNSP + element.TotalQtyConsumption *element.WorkSheetNSP;
            element.WorkSheetNSP= element.TotalQtyConsumption * element.WorkSheetNSP;
          }
          if ((element.WorkSheetLanded != undefined) && (element.TotalQtyConsumption != undefined)){
            _AMCVProfitablity.TotalLandedCost = _AMCVProfitablity.TotalLandedCost + element.TotalQtyConsumption *element.WorkSheetLanded;
            element.WorkSheetLanded= element.TotalQtyConsumption * element.WorkSheetLanded;
          }
          if ((element.BookingLanded != undefined) && (element.TotalQtyConsumption != undefined)){
        
            _AMCVProfitablity.TotalBookLC = _AMCVProfitablity.TotalBookLC + element.TotalQtyConsumption * element.BookingLanded;
            element.BookingLanded= element.TotalQtyConsumption * element.BookingLanded;
            
          }
          this.spraAmcvTotalValue.TotBookingLanded= _AMCVProfitablity.TotalBookLC;
          this.spraAmcvTotalValue.TotSaleValue= _AMCVProfitablity.GrandTotSale;
          this.spraAmcvTotalValue.TotPriceList= _AMCVProfitablity.GrandTotPriceList;
          this.spraAmcvTotalValue.TotWorkSheetLanded= _AMCVProfitablity.TotalLandedCost;
          this.spraAmcvTotalValue.TotWorkSheetNSP= _AMCVProfitablity.TotalWSNSP;
          if(_AMCVProfitablity.GrandTotSale!=0)
          {
            _AMCVProfitablity.GPriceList = (((_AMCVProfitablity.GrandTotSale - _AMCVProfitablity.GrandTotPriceList) / (_AMCVProfitablity.GrandTotSale)) * 100).toFixed(2)+"%";
            _AMCVProfitablity.GPWSNSP = (((_AMCVProfitablity.GrandTotSale - _AMCVProfitablity.TotalWSNSP) / (_AMCVProfitablity.GrandTotSale)) * 100).toFixed(2)+"%";
            _AMCVProfitablity.GPLandedCost = (((_AMCVProfitablity.GrandTotSale - _AMCVProfitablity.TotalLandedCost) / (_AMCVProfitablity.GrandTotSale)) * 100).toFixed(2)+"%";
            _AMCVProfitablity.GPBookLC = (((_AMCVProfitablity.GrandTotSale - _AMCVProfitablity.TotalBookLC) / (_AMCVProfitablity.GrandTotSale)) * 100).toFixed(2)+"%";
            // this.AMCVProfitablity.GPriceList =   this.GPriceList +"%";
            // this.AMCVProfitablity.GPWSNSP =   this.GPWSNSP +"%";
            // this.AMCVProfitablity.GPLandedCost =   this.GPLandedCost +"%";
            // this.AMCVProfitablity.GPBookLC =   this.GPBookLC +"%";
          }
         
        }
  
        if(index ==  this.SpraAmcvParams.length-1)
        {        
          // setTimeout(() => {
          //   this.AMCVProfitablity = _AMCVProfitablity;
          //   this.GetAMCVTotalValues.emit(this.spraAmcvTotalValue);
          // },1000);
          this.EmiAMCVTotalValues(_AMCVProfitablity);
        
        }
  
        
      });
    }

  }

EmiAMCVTotalValues(_AMCVProfitablity:AMCVProfitablity){
  setTimeout(() => {
    this.AMCVProfitablity = _AMCVProfitablity;
    this.GetAMCVTotalValues.emit(this.spraAmcvTotalValue);
  },1000);
}


  async GetSPRAPriceListData(product: SpraAmcvParams, CounterID: number, SaleType: string, DistanceID: Array<number>, index: number, Qty: number, TotCnt: number, TotQty: number,Tc:number = 0, FGQty: Array<number> = [0]) {
    // console.log("dfdfdfdf");
    let PriceListAmt: number = 0;
    let WorkSheetNSPAmt: number = 0;
    let WorkSheetLandedAmt: number = 0;
    let BookingLandedAmt: number = 0;
    let Quantity: number = 0;
    if (SaleType == 'CSA')
    {

      const mutex = new Mutex();
    //  let  TotProdCntAndDistance:number =  DistanceID.length * TotCnt;
      await Promise.all(DistanceID.map(async (element: any,DistIndex:number) => {
        await mutex.runExclusive(async () => {
            //looped around the product list to get the csa base based on the distance and quantity of the FG.
            await Promise.all(product.ProductList.map(async (PId:any, PIndex: number) => {
              await this._MasterService.GetSPRAPriceListData(PId, CounterID, SaleType, element).then((d): any => {
                this.PriceListApiCount +=1 ; 
                if (d) {
                  let data: any = JSON.parse(d.toString());
                  // console.log(FGQty[PIndex]);
                  Quantity += FGQty[PIndex];
                  PriceListAmt = PriceListAmt + data.PriceList * FGQty[PIndex];
                  WorkSheetNSPAmt = WorkSheetNSPAmt + data.WorkSheetNSP * FGQty[PIndex];
                  WorkSheetLandedAmt = WorkSheetLandedAmt + data.WorkSheetLanded * FGQty[PIndex];
                  BookingLandedAmt = BookingLandedAmt + data.BookingLanded * FGQty[PIndex];
                }
              });
            }));   
          });

          if (DistIndex == DistanceID.length - 1) {
            PriceListAmt = parseFloat((PriceListAmt / Quantity).toFixed(2));
            WorkSheetNSPAmt = parseFloat((WorkSheetNSPAmt / Quantity).toFixed(2));
            WorkSheetLandedAmt = parseFloat((WorkSheetLandedAmt / Quantity).toFixed(2));
            BookingLandedAmt = parseFloat((BookingLandedAmt / Quantity).toFixed(2));
            
            if (product.TotalCopy != undefined) {
                this.BindCsaUnitPrice.emit(product);
  
                product.PriceList = PriceListAmt * product.TotalCopy;
                product.WorkSheetNSP = WorkSheetNSPAmt * product.TotalCopy;
                product.WorkSheetLanded = WorkSheetLandedAmt * product.TotalCopy;
                product.BookingLanded = BookingLandedAmt * product.TotalCopy;
  
                
              }
          } 
  

        }));

        this.CalculateGrandTotal();
    }else
    {
      if (product.ProductId != undefined) { 
        await this._MasterService.GetSPRAPriceListData(product.ProductId, 0, SaleType, 0).then((d): any => {
          this.PriceListApiCount +=1 ;
          if (d) {
            let data: any = JSON.parse(d.toString());
            product.PriceList = data.PriceList;
            product.WorkSheetNSP = data.WorkSheetNSP;
            product.WorkSheetLanded = data.WorkSheetLanded;
            product.BookingLanded = data.BookingLanded;
            // console.log("----------"+ index + " , " + TotCnt + " , " + product.CounterDesc + "----------------");
            // console.log(product.ProductCode); 
            // console.log(product.BookingLanded);

            // CHANGED BY RAJAN SINGH ON 19 JULY 2021 -->> AS FUNCTION CALLING IS BY LOOP
            // AND API CALLING IS ASYNC , API CALLING AND RESPONSE ORDER BY UNPREDICATABLE TO HANDLE THAT
            // if (index == TotCnt - 1) {
              if (this.PriceListApiCount == TotCnt) {
              this.CalculateGrandTotal();
            }
          }
        });
      }     
    }
   
    // else
    // {
    //   this._MasterService.GetSPRAPriceListData(0, CounterID, SaleType,DistanceID).subscribe((d): any => {
    //     if (d) {
    //       let data: any =JSON.parse(d.toString());
    //       product.PriceList=data.PriceList;
    //       product.WorkSheetNSP = data.WorkSheetNSP;
    //       product.WorkSheetLanded = data.WorkSheetLanded;
    //       product.BookingLanded = data.BookingLanded;
    //     }

    //   });

    // }


  }

  RecalculatePLDetail(buttonclick:boolean = false)
  {
    if(this.ProfitTag==true)
    {
      if(buttonclick){
        this.CaltotValTag='N';
       this.CalculateTotalSaleValue();
      }
      
    }
    setTimeout(() => {
    }, 1000);
  }
}
